"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
// var HttpsProxyAgent = require('https-proxy-agent');
// const httpsAgent = new HttpsProxyAgent('http://127.0.0.1:9090')
var initialization = function (config) {
    var axiosInstance = axios_1.default.create(config);
    /*
        Add default headers, interceptors etc..
    */
    return axiosInstance;
};
exports.default = initialization;
//# sourceMappingURL=axiosSetup.js.map